import { useState, useEffect } from "react";

interface NavigationProps {
  onNavigate?: (page: string) => void;
}

export const Navigation = (props: NavigationProps) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    try {
      const response = await fetch("/api/auth/validate-session");
      setIsAuthenticated(response.ok);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleAuthClick = (e: React.MouseEvent) => {
    if (isAuthenticated) {
      e.preventDefault();
      if (props.onNavigate) {
        props.onNavigate("account");
      }
    } else {
      // Let the default href behavior work for sign in
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          {/* <a className="navbar-brand page-scroll" href="#page-top"></a>{" "} */}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li>
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li> */}
            {/* <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li> */}
            <li>
              <a href="#about" className="page-scroll">
                Contact
              </a>
            </li>
            {!loading && (
              <li>
                <a
                  href={isAuthenticated ? "#account" : "/api/auth/signin"}
                  onClick={handleAuthClick}
                  style={{
                    fontWeight: isAuthenticated ? "600" : "normal",
                  }}
                >
                  {isAuthenticated ? "Account" : "Sign Up / Log In"}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
